import {ValueObject} from '@s-ui/domain'

export class UpdateSellerTradeDataRequestTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.address
   * @param {String} data.bankAccount
   * @param {String} data.city
   * @param {String} data.lastName
   * @param {String} data.name
   * @param {String} data.personalId
   * @param {String} data.phone
   * @param {String} data.tradeId
   * @param {String} data.zipCode
   */
  constructor({address, bankAccount, city, lastName, name, personalId, phone, tradeId, zipCode}) {
    super()

    this._address = address
    this._bankAccount = bankAccount
    this._city = city
    this._lastName = lastName
    this._name = name
    this._personalId = personalId
    this._phone = phone
    this._tradeId = tradeId
    this._zipCode = zipCode
  }

  static create = ({
    address = '',
    bankAccount,
    city = '',
    lastName = '',
    name = '',
    personalId = '',
    phone,
    tradeId,
    zipCode = ''
  }) => {
    return new UpdateSellerTradeDataRequestTransactionsValueObject({
      address,
      bankAccount,
      city,
      lastName,
      name,
      personalId,
      phone,
      tradeId,
      zipCode
    })
  }

  getTradeId() {
    return this._tradeId
  }

  toJSON() {
    return {
      address: this._address.trim(),
      bankAccount: this._bankAccount,
      city: this._city.trim(),
      lastName: this._lastName.trim(),
      name: this._name.trim(),
      personalId: this._personalId.trim(),
      phone: this._phone,
      tradeId: this._tradeId,
      zipCode: this._zipCode.trim()
    }
  }
}
